module.exports = __webpack_public_path__ + "static/media/ic-office.23a3ecb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-office.svg
// module id = 649
// module chunks = 14